export default __webpack_public_path__ + "static/media/trailer_gray.0f63a4c8.svg";